import React, { Fragment } from "react";
import MetaProperty, {
    metaProperties,
} from "components/MetaProperties/MetaProperty";
import { transform, fromPairs } from "lodash";

export function fromFormFields(values, channel, entry) {
    const allKeys = fromPairs(
        channel?.meta.map((meta) => [
            meta.slug,
            {
                channel_meta_id: meta.id,
                slug: meta.slug,
                value: null,
                channel_uuid: meta.uuid,
                type: meta.type,
            },
        ])
    );

    const parsedValues = transform(
        allKeys,
        (result, value, key) => {
            const val = entry?.meta.find((meta) => meta.slug === key);
            result[key] = Object.assign({}, value, val, {
                value: values[key],
            });

            const type = result[key]?.type;
            if (type && result[key].value && metaProperties[type].BeforeSave) {
                result[key].value = metaProperties[type].BeforeSave(
                    result[key].value
                );
            }
        },
        {}
    );

    return parsedValues;
}

export function toFormFields(channel, entry) {
    const allKeys = fromPairs(channel?.meta.map((meta) => [meta.slug, ""]));

    const values = transform(
        allKeys,
        (result, value, key) => {
            const val = entry?.meta.find((meta) => meta.slug === key);
            result[key] = val ? val.value : value;

            const type = val?.channelMeta.type;
            if (type && result[key] && metaProperties[type].BeforeMount) {
                result[key] = metaProperties[type].BeforeMount(result[key]);
            }
        },
        {}
    );

    return values;
}

export default function EntryFields(props) {
    return (
        <Fragment>
            {props.channel?.meta.map((metaProp, index) => (
                <div key={index}>
                    <MetaProperty
                        type={metaProp.type}
                        label={metaProp.label}
                        field={metaProp.slug}
                        metaProps={metaProp.props}
                        nameMask="{field}"
                    />
                </div>
            ))}
        </Fragment>
    );
}
